import { SortOrder, MONTHS } from '../constants'

const getPreviousMonthKey = () => {
  const now = new Date()
  const prevMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1)
  const year = prevMonth.getFullYear().toString()
  const month = (prevMonth.getMonth() + 1).toString().padStart(2, '0')
  return year + month
}

const DEFAULT_MONTH_KEY = getPreviousMonthKey()

const COLUMN_IDS = {
  ACCOUNT: 'account',
  MONTH: 'month',
  CURRENCY: 'currency',
  TOTAL_API_HITS: 'totalApiHits',
  FREE_HITS: 'freeHits',
  OVERAGE_HITS: 'overageHits',
  API_OVERAGE_FEES: 'apiOverageFees',
  ACTIVE_SITES: 'activeSites',
  BILLABLE_SITES: 'billableSites',
  SITES_FEES: 'sitesFees',
  HRT_SITES: 'hrtSites',
  HRT_FEES: 'hrtFees',
  FIXED_FEES: 'fixedFees',
  TOTAL_AMOUNT: 'totalAmount',
  TAX_AMOUNT: 'taxAmount',
  TOTAL_INVOICE: 'totalInvoice',
  CONFIG: 'config',
}

const TABLE_HEADINGS = [
  { id: COLUMN_IDS.ACCOUNT, label: 'Account', sortOrder: SortOrder.ASC },
  { id: COLUMN_IDS.MONTH, label: 'Month', sortOrder: SortOrder.ASC },
  { id: COLUMN_IDS.CURRENCY, label: 'Currency', sortOrder: SortOrder.ASC },
  { id: COLUMN_IDS.TOTAL_API_HITS, label: 'Total API Hits', sortOrder: SortOrder.ASC },
  { id: COLUMN_IDS.FREE_HITS, label: 'Free Hits', sortOrder: SortOrder.ASC },
  { id: COLUMN_IDS.OVERAGE_HITS, label: 'Overage Hits', sortOrder: SortOrder.ASC },
  { id: COLUMN_IDS.API_OVERAGE_FEES, label: 'API Overage Fees', sortOrder: SortOrder.ASC },
  { id: COLUMN_IDS.ACTIVE_SITES, label: 'Active Sites', sortOrder: SortOrder.ASC },
  { id: COLUMN_IDS.BILLABLE_SITES, label: 'Billable Sites', sortOrder: SortOrder.ASC },
  { id: COLUMN_IDS.SITES_FEES, label: 'Sites Fees', sortOrder: SortOrder.ASC },
  { id: COLUMN_IDS.HRT_SITES, label: 'HRT Sites', sortOrder: SortOrder.ASC },
  { id: COLUMN_IDS.HRT_FEES, label: 'HRT Fees', sortOrder: SortOrder.ASC },
  { id: COLUMN_IDS.FIXED_FEES, label: 'Fixed Fees', sortOrder: SortOrder.ASC },
  { id: COLUMN_IDS.TOTAL_AMOUNT, label: 'Total Amount', sortOrder: SortOrder.ASC },
  { id: COLUMN_IDS.TAX_AMOUNT, label: 'Tax Amount', sortOrder: SortOrder.ASC },
  { id: COLUMN_IDS.TOTAL_INVOICE, label: 'Total Invoice', sortOrder: SortOrder.ASC },
  { id: COLUMN_IDS.CONFIG, label: 'Config', sortOrder: null },
]

const CSV_FILE_PREFIX = 'gs_invoices'
const GRAND_TOTAL_LABEL = 'Currency Total'
const ALL_ACCOUNTS_LABEL = 'All Accounts'
const ALL_CURRENCIES_LABEL = 'All Currencies'
const ALL_MONTHS_LABEL = 'All Months'
const EMPTY_TABLE_TEXT = 'No data available'
const FETCH_ERROR_MESSAGE = 'Failed to fetch invoice data'

export {
  SortOrder,
  MONTHS,
  DEFAULT_MONTH_KEY,
  COLUMN_IDS,
  TABLE_HEADINGS,
  CSV_FILE_PREFIX,
  GRAND_TOTAL_LABEL,
  ALL_ACCOUNTS_LABEL,
  ALL_CURRENCIES_LABEL,
  ALL_MONTHS_LABEL,
  EMPTY_TABLE_TEXT,
  FETCH_ERROR_MESSAGE,
}
